import { render } from "./DonneesPatient.vue?vue&type=template&id=2d6e739b&scoped=true"
import script from "./DonneesPatient.vue?vue&type=script&lang=js"
export * from "./DonneesPatient.vue?vue&type=script&lang=js"

import "./DonneesPatient.vue?vue&type=style&index=0&id=2d6e739b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6e739b"]])

export default __exports__